export default {"src":"/_next/static/media/expert_wine_tasting.c5472acb.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};